import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import GetAppIcon from '@mui/icons-material/GetApp';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Tooltip from "@mui/material/Tooltip";
import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

export default function ExportTableToCSV({ dataarray, disabled }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  return (
    <div>
      <Tooltip title="Exporter en CSV">
        <Button
          onClick={() => downloadCSV(dataarray)}
          color={"info"}
          className={classes.actionButton}
          disabled={disabled}
        >
          <GetAppIcon fontSize="large" />
        </Button>
      </Tooltip>
    </div>
  );
}

function convertArrayOfObjectsToCSV(array) {
  let result = "";
  if (array.length > 0) {
    const columnDelimiter = ';';
    const lineDelimiter = '\n';
    const keys = Object.keys(array[0]);

    result = '\ufeff';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    array.forEach(item => {
      let ctr = 0;
      keys.forEach(key => {
        if (ctr > 0) result += columnDelimiter;

        result += item[key];

        ctr++;
      });
      result += lineDelimiter;
    });
  }

  return result;
}

export function downloadCSV(array) {
  const link = document.createElement('a');
  let csv = convertArrayOfObjectsToCSV(array);
  if (csv == null) return;
  const filename = 'export.csv';

  if (csv.includes('#'))
    csv = csv.replaceAll('#', '');
  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }
  link.setAttribute('href', encodeURI(csv));
  link.setAttribute('download', filename);
  link.click();
}
